import React from 'react';
import PageHeader from './PageHeader';
import '../css/Opportunities.css';

const opportunities = [
  {
    id: 'ai',
    image: `${process.env.PUBLIC_URL}/images/Internship_AI.png`,
    title: 'AI/ML Intern',
    description: `Unleash your potential at Manvidia with our internship program. Join MANVIDIA, where AI innovation meets ethical responsibility. We're seeking passionate AI/ML talent to build intelligent agents that transform businesses. Contribute to cutting-edge projects, work with experts, and shape the future of responsible AI.`,
    features: [
      'Personalized Mentorship',
      'Hands-on Experience',
      'Cutting-edge Projects',
      'Career Development',
    ],
  },
  {
    id: 'fullstack',
    image: `${process.env.PUBLIC_URL}/images/Internship_FullStack.png`,
    title: 'Full Stack Development Intern',
    description: `Dive into full-stack development at MANVIDIA. Build innovative applications with us. Work on front-end and back-end technologies, learn from experts, and contribute to impactful projects. Join our team and shape the future of responsible AI.`,
    features: [
      'Full Stack Training',
      'Real-World Projects',
      'Collaborative Environment',
      'Skill Enhancement',
    ],
  },
];

const Opportunities = () => {
  return (
    <div>
      <PageHeader eyebrow="Opportunities" title="Internships at Manvidia">
        Work on real AI and web products alongside our team, and build a portfolio that shows what you can do.
      </PageHeader>

      <div className="page section">
        {opportunities.map((opportunity, index) => (
          <article
            id={opportunity.id}
            className={`feature ${index % 2 === 1 ? 'feature--reverse' : ''}`}
            key={opportunity.id}
          >
            <div className="feature-media">
              <img src={opportunity.image} alt={opportunity.title} />
            </div>
            <div className="feature-body">
              <h2>{opportunity.title}</h2>
              <p>{opportunity.description}</p>
              <ul className="feature-list">
                {opportunity.features.map(feature => (
                  <li key={feature}>{feature}</li>
                ))}
              </ul>
              <div className="apply-box">
                <span>To apply, send your resume to</span>
                <a href="mailto:careers@manvidia.com">careers@manvidia.com</a>
              </div>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
};

export default Opportunities;
